export const NAVIGATION_APPS = [
  { id: "neshan", label: "نشان" },
  { id: "google", label: "گوگل مپ" },
  { id: "apple", label: "اپل مپ" },
  { id: "waze", label: "ویز" },
  { id: "balad", label: "بلد" },
];

const isAndroid = () =>
  typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);

export const parseMapCoordinates = (item) => {
  if (!item) {
    return null;
  }

  const lat = Number(item.lat);
  const lng = Number(item.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  if (item.lat === "null" || item.lng === "null") {
    return null;
  }

  return { lat, lng };
};

export const getNavigationLabel = (item) => {
  if (!item) {
    return "مشتری";
  }

  return (
    item.store_name ||
    [item.name, item.family].filter(Boolean).join(" ").trim() ||
    "مشتری"
  );
};

export const buildNavigationAppUrl = (
  appId,
  { lat, lng, label, originLat, originLng }
) => {
  const destination = `${lat},${lng}`;
  const encodedLabel = encodeURIComponent(label || "مشتری");
  const hasOrigin =
    Number.isFinite(originLat) &&
    Number.isFinite(originLng) &&
    !(originLat === 0 && originLng === 0);

  switch (appId) {
    case "neshan": {
      if (hasOrigin) {
        return `https://nshn.ir/maps?origin=${originLat},${originLng}&destination=${destination}&type=drive`;
      }
      if (isAndroid()) {
        const fallback = encodeURIComponent(`https://nshn.ir/?lat=${lat}&lng=${lng}`);
        return `intent://nshn.ir/?lat=${lat}&lng=${lng}#Intent;scheme=https;package=org.rajman.neshan.traffic.tehran.navigator;S.browser_fallback_url=${fallback};end`;
      }
      return `https://nshn.ir/?lat=${lat}&lng=${lng}`;
    }
    case "google":
      return `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`;
    case "apple":
      return `https://maps.apple.com/?daddr=${destination}&dirflg=d`;
    case "waze":
      return `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
    case "balad":
      return `https://balad.ir/directions?destination=${lat},${lng}`;
    default:
      return `https://www.google.com/maps/search/?api=1&query=${destination}`;
  }
};

export const openNavigationApp = (appId, options) => {
  const url = buildNavigationAppUrl(appId, options);
  if (url.startsWith("intent://")) {
    window.location.href = url;
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};

/** Android: geo URI opens the system map-app chooser when available. */
export const tryAndroidGeoNavigation = ({ lat, lng, label }) => {
  if (!isAndroid()) {
    return false;
  }

  const safeLabel = encodeURIComponent(label || "مشتری");
  window.location.href = `geo:0,0?q=${lat},${lng}(${safeLabel})`;
  return true;
};

export const requestNavigation = ({ lat, lng, label, onShowPicker }) => {
  if (tryAndroidGeoNavigation({ lat, lng, label })) {
    return;
  }
  onShowPicker();
};
